import {meetsContrastGuidelines} from 'polished'
import {themeGetter} from 'quickstart/system'
import {bestContrast} from 'quickstart/utils'

const getFakeCovers = theme => {
  const th = themeGetter(theme)

  // These two foreground colors are our candidates against the palette of
  // primary and secondary colors.
  const foregrounds = [th('colors.textColor'), th('colors.textInvertedColor')]

  return (
    Object.values(th('colorScales.brandForm'))
      // Pair each background color with the highest-contrast foreground color
      // from the candidates (light and dark).
      .map(backgroundColor => ({
        backgroundColor,
        color: bestContrast(foregrounds, backgroundColor),
      }))
      // Only keep pairs that meet the AA contrast standard.
      .filter(
        ({backgroundColor, color}) =>
          meetsContrastGuidelines(backgroundColor, color).AA,
      )
  )
}

export default getFakeCovers
